<template>
  <div class="mw-split-container">
    <split-pane :defaultSize="208">
      <template slot="paneL">
        <div class="mw-split-left">
           <div class="mw-toolbar__body">
            <mw-tree :treeData="treeData" :defaultParams="defaultTreeParams" :async="false" :contextMenuItem="contextMenuItem" :dragEnable="true"
              :expandedFirst="true" :selectFirst="true" ref="componentTree" @changed="changed"></mw-tree>
          </div>
        </div>
      </template>
      <template slot="paneR">
        <div class="mw-split-right">
          <toolbar-table :layout="layout" :autoLoad="false" ref="dataTable" :defaultParams="defaultParams">
            <span slot="dropDown">
              <el-button @click="removeData">
                <i class="fa fa-remove"></i>删除
              </el-button>
              <el-button @click="activate">
                <i class="fa fa-rotate-right"></i>恢复
              </el-button>
            </span>
            <span>&nbsp;</span>
          </toolbar-table>
        </div>
      </template>
    </split-pane>
  </div>

</template>
<script>
  export default {
    components: {

    },
    data() {
      let me = this;
      return {
        layout: [],
        contextMenuItem:[],
        defaultTreeParams:{},
        defaultParams:{},
        treeData:[],
        params:{"isAdmin":true},
        buttons:[],
        isFirstOpen:true
      }
    },
    mounted(){
        let me = this;
        me.getTreeData();
        me.layout = [
            [{
            span:0,
            type: 'menu',
            label: '回收站',
            api: 'process.listWaitDeleteDoc',
            defaultParams:me.params,
            defaultSort:[],
            nowrap:false,
            columns: [
            {type: 'selection',reserve: true},
            {label:'序号',width:'50',type:'index'},
            {prop: 'businessName', label: '标题',tooltip:true},
            {prop: 'startUserName', label: '拟稿人',width:'90',tooltip:true},
            {prop: 'startTime', label: '拟稿时间',width:'160',tooltip:true},
            {prop: 'processDefinitionName', label: '流程定义名称',width:'170',tooltip:true},
            {prop: 'suspendTime', label: '删除时间',width:'160',tooltip:true},
            ]
            },{
              span: 19,
              type: 'button',
              items: me.buttons,
              suffixSlot:"dropDown"
            },
            {
                span: 5,
                type: 'searchText',
                offset: 0,
                name:'businessNameLike',
                tip:"标题",
            }]
        ];
        me.mwRef('dataTable').mwRef('dataTable').$on("rendered",function(dataList,el){
          if(me.mwRef('dataTable').mwRef('dataTable').filters.filter&&me.mwRef('dataTable').mwRef('dataTable').filters.filter.businessNameLike){
            me.params.moduleId = "";
          }
        })
    },
    methods: {
        getTreeData() {
          var me = this;
          me.treeData = [];
          $.post(window.$servicePath+"/api/process/listWaitDeleteDocTree",{"isAdmin":true},function(res){
          //this.mwApi.app.listComponentType().then(res => {
            var datas = res.result?res.result:res;
            if(datas.length>0){
              me.treeData = datas;
            }
          });
        },
        changed:function(data){
          let me =this;
          if(!data.id){
            return;
          }
          me.params.moduleId = data.id;
          me.defaultParams.flag=true;
          if(this.mwRef('dataTable').mwRef('dataTable').filters.filter && this.mwRef('dataTable').mwRef('dataTable').filters.filter.businessNameLike){
            this.mwRef('dataTable').mwRef('dataTable').filters.filter={};
          }
          this.mwRef('dataTable').clearSelection();
          this.mwRef('dataTable').mwRef('dataTable').currentChange(1);
          // this.mwRef('dataTable').clearFilters();
          // this.mwRef('dataTable').refreshTable();
        },
        refreshTable:function(){
          var me = this;
          me.getTreeData();
          me.mwRef("componentTree").refresh();
          if(this.mwRef('dataTable').mwRef('dataTable').filters.filter&&this.mwRef('dataTable').mwRef('dataTable').filters.filter.businessNameLike){
            this.mwRef('dataTable').mwRef('dataTable').filters.filter={};
          }
        },
        removeData:function(){
          let me = this;
          let dataTable = me.mwRef('dataTable');
          let multipleSelection = dataTable.getMultipleSelection();
          if(multipleSelection.length==0){
              this.mwMsg('warning','请选择需要删除的数据!');
              return false;
          }
          me.mwConfirm($lang('记录删除后无法恢复，您确认是要删除？'), 'info', {type: 'warning'}).then(()=>{
            let businesses=[];
            multipleSelection.forEach(t =>{
              businesses.push({businessId:t.businessId, draftsDocId:t.draftsDocId, batchId:t.batchId, formEntityKey:t.formEntityKey, moduleId:t.moduleId,moduleFullName:t.moduleFullName});
            });
            PF.api.process.batchMarkDelete(businesses).then(res=>{
              if(res.success) {
                let ids=businesses.map(t =>{ return t.businessId});
                let moduleFullName=businesses[0].moduleFullName;
                PF.invoke("sys-es-publish-service.docUnpublish",{ids:ids,catalogName:moduleFullName}).then(function(res){});
                me.refreshTable();
              }
            });
            //PF.func.bpm.markDelete(multipleSelection,me);
          }).catch(()=>{
          });

        },
        activate:function(){
          let me = this;
          let dataTable = me.mwRef('dataTable');
          let multipleSelection = dataTable.getMultipleSelection();
          if(multipleSelection.length==0){
              this.mwMsg('warning','请选择需要恢复的数据!');
              return false;
          }
          let businesses=[];
          multipleSelection.forEach(t =>{
            businesses.push({businessId:t.businessId, draftsDocId:t.draftsDocId, batchId:t.batchId, formEntityKey:t.formEntityKey, moduleId:t.moduleId});
          });
          me.mwApi.process.batchActivateDocs(businesses).then(res => {
            if (res.success) {
              this.mwMsg('message','已恢复');
              me.refreshTable();
            }
          });
        },
        handleMoreCommand(command){
          let me=this;
          if(command === 'import'){
            this.mwRef('impDialog').show();
          }
      },

    },

    watch:{

    }
  }
</script>

<style scoped>
  .mw-app__edit{
    text-align:left;
  }
  .menu-item{
    position: relative;
    cursor:pointer;
    line-height: 30px;
    color: #033d49;
    font-weight: 400;
    font-size: 14px;
  }
  .menu-item:hover{
    background-color: #e7f4f9;
  }
  .menu-item>a{
    display:block;
    padding:2px 0px 2px 20px;
    height:100%;
  }
  .menu-item i {
    color:#ea972c;
  }
  .menu-item>div.active{
    background: linear-gradient(to bottom, #beebff 0%, #a8e4ff 100%);
  }
  .mask-layer {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    cursor: no-drop;
  }
  .mask-layer:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0px;
    right: 0px;
    background: rgba(161, 161, 161, 0.3);
    height: 100%;
    z-index: -1;
  }
  .menu-item.disable-router {
    color: darkgray;
  }
  .menu-item.disable-router i {
    color: #f9d29e;
  }

</style>



// WEBPACK FOOTER //
// src/modules/index/views/systemSet/set/recycleBin.vue